import validate from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/pages/runtime/validate.js";
import permission_45page_45global from "/builds/synthese-et-medias/data-center-front/middleware/permission-page.global.ts";
import manifest_45route_45rule from "/builds/synthese-et-medias/data-center-front/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  permission_45page_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}